var mscc;
function ForgotPasswordViewModel(options) {
    var viewModel = this;
    var hasConsented = false;

    return $.extend(viewModel, {
        forgotOption: ko.observable(options.forgotOption),
        requestProcessed: ko.observable(),
        requestProcessing: ko.observable(),
        secretQuestion: ko.observable(),
        forgotOptionMatchesElemName: function () {
            return viewModel.forgotOption() == $(this).data('name');
        },
        submitForgotRequest: function () {
            $(options.containerElem)
                .find('form')
                .filter(viewModel.forgotOptionMatchesElemName)
                .submit();
        },
        forgotPassword: function (formElem) {
            submit($(formElem), function (data) {
                if (data && data.SecurityQuestion) {
                    viewModel.secretQuestion(data.SecurityQuestion);
                    return false;
                }
            });
        },
        forgotUsername: function (formElem) {
            submit($(formElem));
        },
        done: function () {
            window.location.href = options.cancelUrl;
        },
    });

    function submit($form, onSuccess) {
        var formData;

        setCookieConsent();
        if ($form.valid()) {
            // need to serialize the data before setting the "request processing" state,
            // otherwise the form will become disabled and no data will be collected
            formData = $form.serialize();

            viewModel.requestProcessing(true);

            $.advertiser.ajaxPost({
                url: $form.data('url'),
                data: formData,
                useAjaxSuccessHandler: true,
                onSuccess: function (data) {
                    if (!$.isFunction(onSuccess) || onSuccess(data) !== false) {
                        viewModel.requestProcessed(true);
                    }
                },
                onAjaxComplete: function () {
                    viewModel.requestProcessing(false);
                },
            });
        }
    }

    function setCookieConsent() {
        if (!hasConsented) {
            //If the EU Cookie Compliance banner is shown, give consent
            if ($('#msccBanner').size() > 0) {
                mscc && mscc.setConsent();
            }

            hasConsented = true;
        }
    }
}

function ResetPasswordViewModel(options) {
    var viewModel = this;

    return $.extend(viewModel, {
        requestProcessed: ko.observable(),
        requestProcessing: ko.observable(),
        resetPassword: function (formElem) {
            var $form = $(formElem);
            var formData;
            if ($form.valid()) {
                // need to serialize the data before setting the "request processing" state,
                // otherwise the form will become disabled and no data will be collected
                formData = $form.serialize();
                viewModel.requestProcessing(true);

                $.advertiser.ajaxPost({
                    url: $form.data('url'),
                    data: formData,
                    useAjaxSuccessHandler: true,
                    onSuccess: function (data) {
                        viewModel.requestProcessed(true);
                    },
                    onAjaxComplete: function () {
                        viewModel.requestProcessing(false);
                    },
                });
            }
        },
        done: function () {
            window.location.href = options.cancelUrl;
        },
    });
}

window.ForgotPasswordViewModel = ForgotPasswordViewModel;
window.ResetPasswordViewModel = ResetPasswordViewModel;
